import { render } from "./LabelWithTooltip.vue?vue&type=template&id=01681607"
import script from "./LabelWithTooltip.vue?vue&type=script&lang=js"
export * from "./LabelWithTooltip.vue?vue&type=script&lang=js"
script.render = render

export default script